import { useState, useEffect } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  // UncontrolledDropdown,
  // DropdownToggle,
  // DropdownMenu,
  // DropdownItem,
  // NavbarText,
} from "reactstrap";

import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  ROOT,
  DOWNLOADS,
  CERTIFICATES,
  STRUCTURE,
  DIRECTION_COMMITTEE,
  EXAMINATION_COMMITTEE,
  ATBS,
  CONTACTS,
} from "../router/RouteNames";

import LanguageSelector from "./LanguageSelector";
import asrcertperslogo from "../resources/asrcertperslogo.png";
import iiwlogo from "../resources/iiwlogov2.png";
import ewflogo from "../resources/ewflogo.png";

import "../styles/Navbar.css";

function NavbarComponent(args) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((previous) => !previous);

  const navigate = useNavigate();

  const { t } = useTranslation();
  const location = useLocation();

  const iiwURL = "https://iiwelding.org/";
  const ewfURL = "https://www.ewf.be/";

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const handleNavigate = (path) => {
    setIsOpen(false);
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <Navbar className="navbar" expand="lg" {...args}>
        <div className="brands">
          <NavbarBrand>
            <img
              onClick={() => navigate(ROOT.name)}
              src={asrcertperslogo}
              width="120"
              height="66"
              alt="ASRCERTPERS"
            />
          </NavbarBrand>
          <div className="navbrand-partners">
            <a href={iiwURL} target="_blank" rel="noopener noreferrer">
              <img
                className="navbar-partner-logo"
                src={iiwlogo}
                width="40"
                height="40"
                alt="IIW"
              />
            </a>
            <a href={ewfURL} target="_blank" rel="noopener noreferrer">
              <img
                className="navbar-partner-logo"
                src={ewflogo}
                width="40"
                height="40"
                alt="EWF"
              />
            </a>
          </div>
        </div>

        <NavbarToggler
          onClick={toggle}
          aria-expanded={isOpen}
          aria-controls="main-navbar-menu"
        />
        <Collapse isOpen={isOpen} navbar id="main-navbar-menu">
          <Nav className="ms-auto" navbar>
            <NavItem>
              <NavLink onClick={() => handleNavigate(STRUCTURE.name)}>
                {t("structure_tab")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink onClick={() => handleNavigate(ATBS.name)}>ATBs</NavLink>
            </NavItem>

            <NavItem>
              <NavLink onClick={() => handleNavigate(CERTIFICATES.name)}>
                {t("certifications_tab")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink onClick={() => handleNavigate(DOWNLOADS.name)}>
                {t("downloads_tab")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink onClick={() => handleNavigate(CONTACTS.name)}>
                {t("contacts_tab")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://stargatenasdts.cz5.quickconnect.to/#/signin"
                onClick={() => setIsOpen(false)}
              >
                Intranets
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink onClick={() => handleNavigate(DIRECTION_COMMITTEE.name)}>
                {t("direction_committee_tab")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                onClick={() => handleNavigate(EXAMINATION_COMMITTEE.name)}
              >
                {t("examination_committee_tab")}
              </NavLink>
            </NavItem>

            <NavItem>
              <LanguageSelector />
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default NavbarComponent;
